import { Injectable, OnDestroy, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, startWith } from 'rxjs';
import { SubSink } from 'subsink';
import { selectCatalog } from '../root-store/catalog-store/selectors';
import { RootState } from '../root-store/root-state.model';
import { BackendService } from './backend.service';
import { CheckoutLabels, ObjectChoiceLabels, PaymentLabels } from './sxc.models';

@Injectable({
  providedIn: 'root'
})
export class CustomLabelsService implements OnDestroy {
  private subs = new SubSink()
  checkout = signal<CheckoutLabels>({})
  objectChoice = signal<ObjectChoiceLabels>({})
  payment = signal<PaymentLabels>({})

  constructor(
    private backend: BackendService,
    private store: Store<RootState>,
    translate: TranslateService
  ) {
    this.subs.sink = combineLatest([this.store.select(selectCatalog), translate.onLangChange.pipe(startWith({ lang: translate.currentLang }))])
      .subscribe(([catalog]) => {
        this.backend.getCustomLabels(catalog.id, catalog.parentCatalogId).subscribe(customLabels => {
          this.checkout.set(customLabels.Checkout)
          this.objectChoice.set(customLabels.ObjectChoice)
          this.payment.set(customLabels.Payment)
        })
      })
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe()
  }
}
